// extracted by mini-css-extract-plugin
export default {"page":"main_page__VSM2m","pageElement":"main_pageElement__bH19D","mainPage":"main_mainPage__6DVtO"};